import React from 'react';
import { IAuthFormsProps } from './interface';

export const newStepForm = (Form: React.FC<IAuthFormsProps>, props: IAuthFormsProps) => {
    return <Form {...props} />;
};